import React from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import {uiConfig, auth} from '../firebase/firebase.js';

class Auth extends React.Component {
    componentDidMount() {
        
    }
    render() {
        return (
            <div style={{color:"black"}}>
            {!this.props.loggedIn &&
            <div>
            <h1>Welcome to Raccoon</h1>
            <p>Please sign-in:</p>
            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth}/>
            </div>}
            { this.props.loggedIn && <div>Currently Logged In</div>}
            </div>
        );
    }
}

export default Auth;